import { useGlobalState } from 'state/globalState'
import { Navigate, Outlet } from 'react-router-dom'

export const NoTeamRoute = () => {
  const { user } = useGlobalState();

  return (user && !user.team) ? <Outlet /> : <Navigate to='/' />;
}
